module.exports = __webpack_public_path__ + "img/car-1.fbe61d94.png";